module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/19NqI8m/images/cover.jpg?1703000716456",
      "alt": "This image is the cover for the book Undertown, Volume 1, Undertown"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Undertown, Volume 1, Undertown\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“This fantasy manga presents the right mix of familiar tropes along with new ideas that should capture the imaginations of more than a few readers.")]), _vm._v("” —"), _c('b', [_c('i', [_vm._v("Publishers Weekly")])]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Meet Sama, a young boy who is so sad that tears have literally stained his cheeks. Sama's father has had a heart attack, and doctors give him a month to live. With his teddy bear in tow, Sama crawls under his bed and finds a magical portal to a strange realm called Undertown. What is this dark new world? To find out, Sama begins a journey through the depths of Undertown, where he searches for The Sugar Stone, a magical object that might be able to save his dad!  \n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jim Pascoe, Jake Myler\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Tokyopop Verlag\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0